import { render, staticRenderFns } from "./PatientVideoCall.vue?vue&type=template&id=5a7df36a&scoped=true&"
import script from "./PatientVideoCall.vue?vue&type=script&lang=ts&"
export * from "./PatientVideoCall.vue?vue&type=script&lang=ts&"
import style0 from "./PatientVideoCall.vue?vue&type=style&index=0&id=5a7df36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7df36a",
  null
  
)

export default component.exports